import React, { Fragment, useContext, useState } from 'react';

import classnames from 'classnames';
import _ from 'lodash';

import { PopupContext } from '@app/dev/contexts/popup';
import { useTranslation } from '@common/hooks/translation';
import { POPUPS } from '@common/constants/popups';

import { getStepsList } from './stepsConfig';
import './style.scss';
import { createTerminalPlayer } from '@app/dev/helpers/user/createTerminalPlayer';
import Config from '@app/dev/config/main';
import { getPhoneCodeByCountry } from './constants/fieldRegistry';

const RegistrationForm = () => {
  const t = useTranslation();
  const [{ closePopup, openPopup }] = useContext(PopupContext);

  const { country: defaultCountry = 'Armenia' } = Config.registrationFormConfigs || {};
  const defaultPhoneCode = getPhoneCodeByCountry(defaultCountry) || '+374';

  const [form, setForm] = useState({
    phoneNumber: {
      code: defaultPhoneCode,
      phone: '',
    },
    country: {
      name: defaultCountry,
    },
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);

  const steps = getStepsList();
  const stepData = steps[currentStep].step;
  const isLastStep = currentStep === steps.length - 1;

  const onContinue = async (successPopupWithBenefits = true) => {
    const formErrors = stepData.validate(form);

    setErrors(formErrors);

    if (!_.isEmpty(formErrors)) return;

    if (!isLastStep) {
      setCurrentStep(currentStep + 1);
      return;
    }

    setLoading(true);

    const res = await createTerminalPlayer(form, successPopupWithBenefits);

    if (res?.errors) setErrors(res.errors);
    setLoading(false);
  };

  const onBack = () => {
    if (currentStep === 0) closePopup();

    setCurrentStep(currentStep - 1);
  };

  const StepComponent = stepData.component;

  return (
    <div className="popup-content popup-small popup-registration-new-form">
      <div className="popup-title-block">
        <p className="popup-title">{t('REGISTRATION')}</p>
        <i onClick={() => closePopup()} className="global-icon icon-Close close-popup" />
      </div>
      <div className="registration-steps-block">
        {
          steps.map((item, index) => {
            const isStepPassed = index < currentStep;
            return (
              <Fragment key={item.name}>
                <div className="item">
                  {item.label && <p className="title">{item.label}</p>}
                  <div className={`count ${currentStep === index && 'active'} ${isStepPassed && 'passed'}`}>
                    {isStepPassed ? <i className="global-icon icon-regular-checkmark" /> : index + 1}
                  </div>
                </div>
                <div className="dividing-line" />
              </Fragment>
            );
          })
        }
      </div>
      <div className="popup-main-content">
        <StepComponent
          form={form}
          setForm={setForm}
          errors={errors}
          setErrors={setErrors}
          fields={stepData.fields}
        />
      </div>
      <div className="popup-actions-registrationForm">
        {currentStep === 0 ? <></> : <button
          onClick={onBack}
          className="popup-cancel-button"
          type="button"
        >
          {t('Back')}
        </button>}
        <button
          type="button"
          onClick={onContinue}
          className={classnames('popup-confirm-button', { disabled: loading })}
        >
          {t(isLastStep ? 'Create Account' : 'Next')}
        </button>
      </div>
      <div
        className="sign-in"
      >
        {t('have an account?')}
        &nbsp;
        <span onClick={() => openPopup(POPUPS.LOGIN_FORM, { signInToAdmin: false, popupPosition: 'top' })}>{t('sign in')}</span>
      </div>
    </div>
  );
};

export default RegistrationForm;
